import {useState, useEffect} from 'react'
import {storage, firestore} from '../firebase/config' 
import { ref, uploadBytesResumable, getDownloadURL } from "@firebase/storage";
import { collection, addDoc } from '@firebase/firestore'

export const useStorage = (file) => {
    
    const [progress, setProgress] = useState(0);
    const [url, setUrl] = useState(null);
    const [err, setErr] = useState(null); 
    // const storageRef = ref(storage, `/items/resizedItems/${file.name}`) // to store inside folders

    useEffect(() =>{
        if(file){
            var today = new Date();
            var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
            var time = today.getHours()+'-'+today.getMinutes()+'-'+today.getSeconds();
            var dateTime = date+'_'+time; 
            
            const fileName = file.name.split('.')[0] + dateTime;
            const storageRef = ref(storage, fileName)
            // const collectionRef = collection('images')
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on('state_changed', (snap) =>{
                let percentage = ( snap.bytesTransferred / snap.totalBytes ) * 100;
                setProgress(percentage)
            }, (err) =>{
                setErr(err)
            }, async () =>{
                const url = await getDownloadURL(storageRef);
                await addDoc(collection(firestore, "images"), {
                    imageUrl : url,
                    createdAt : dateTime
                  });
                setUrl(url)
            })
        }
    },[file])

    return {progress, url, err};
}
